import script from "./ChatConversationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatConversationHeader.vue?vue&type=script&setup=true&lang=js"

import "./ChatConversationHeader.vue?vue&type=style&index=0&id=22a81d96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a81d96"]])

export default __exports__